import XBandScaleAxis from '@/components/core/lume-axis/composables/x-band-scale-axis';
import YBandScaleAxis from '@/components/core/lume-axis/composables/y-band-scale-axis';
import XLinearScaleAxis from '@/components/core/lume-axis/composables/x-linear-scale-axis';
import YLinearScaleAxis from '@/components/core/lume-axis/composables/y-linear-scale-axis';

export default {
  'x-band-scale-axis': XBandScaleAxis,
  'y-band-scale-axis': YBandScaleAxis,
  'x-linear-scale-axis': XLinearScaleAxis,
  'y-linear-scale-axis': YLinearScaleAxis,
};
